import React, { useContext } from 'react';
import styles from './LightBoxButton.module.scss';
import { LightBoxContext } from './LightBoxContext';
import LightBox from './LightBox';

const LightBoxButton = ({ image }) => {
  let { handleLightBox } = useContext(LightBoxContext);

  return <button type="button" className={styles.lightBoxButton} onClick={() => handleLightBox(<LightBox image={image} />)} />;
};

export default LightBoxButton;
